export enum CookieConsentType {
  STRICTLY_NECESSARY = 'C0001',
  PERFORMANCE = 'C0002',
  FUNCTIONAL = 'C0003',
  TARGETING = 'C0004',
}

export type CookieConsentState = Record<keyof typeof CookieConsentType, boolean>;

export type CookieConsentCallback = (consentState: CookieConsentState) => void;

export type OneTrustCookieConsentMethods = {
  ToggleInfoDisplay: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  OnConsentChanged: (cb: (arg?: any) => void) => void;
};
